import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';

import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { CellRendererTypes } from '../../shared/widgets/data-grid/enums/cell-renderer.enum';
import { FilterTypes } from '../../shared/widgets/data-grid/enums/filter-types.enum';
import { TableColumn } from '../../shared/widgets/data-grid/interfaces/table-column.interface';

import { Subject } from 'rxjs';
import { Enums } from '../../shared/models/enums';
import { ModalService } from '../../shared/services/modal.service';

@Injectable()
export class GenerateEligibilityService {
    modalRef: MDBModalRef;
    confirmationStatus = Enums.confirmationStatus;
    private callbackProjDOcUploadModalClose = new Subject<any>(); // Source
    eventCallbackProjDocuUploadModalClose$ = this.callbackProjDOcUploadModalClose.asObservable(); // Stream
    constructor(private modalService: ModalService) { }

    projectNameCellRenderer(rowData) {
        return rowData.unreadNotification ? `<span class="grid-cell-notification me-1"><i class="fas fa-circle text-buttercup"></i></span>` : '';
    }

    auditorCellRenderer(rowData) {
        if (rowData.audAccepted == true && rowData.auditorName) {
            return `<div class="text-truncate"><i class="fas fa-check text-green me-1" title="Accepted"></i><span title="` + rowData.auditorName + `">` + rowData.auditorName + `</span></div>`;
        } else if (rowData.audAccepted == null && rowData.auditorName) {
            return `<div class="text-truncate"><i class="fas fa-exclamation-triangle text-yelloworange me-1" title="Action Pending"></i><span title="` + rowData.auditorName + `">` + rowData.auditorName + `</span></div>`;
        } else {
            return '';
        }
    }

    savingsCellRenderer(rowData, field) {
        if (rowData[field]) {
            const percent = parseFloat(rowData[field].replace('%', ''));
            if (!Number.isNaN(percent) && percent >= 20) {
                return `<div class="text-green text-truncate" title="` + rowData[field] + `">` + rowData[field] + `</div>`;
            } else {
                return rowData[field];
            }
        } else {
            return '';
        }
    };

    dateCellRenderer(rowData, field) {
        if (rowData[field]) {
            const value = formatDate(rowData[field], 'yyyy-MM-dd hh:mm a', 'en-US');
            return `<div class="text-truncate" title="` + value + `">` + value + `</div>`;
        } else {
            return '';
        }
    }

    fixedTo2Decimal(rowData, field) {
        if (rowData[field]) {
            const value = parseFloat(rowData[field]);
            return (!Number.isNaN(value)) ? `<div class="text-truncate" title="` + value.toFixed(2) + `">` + value.toFixed(2) + `</div>` : rowData[field];
        } else {
            return '';
        }

    }
    // Show User Setting Modal

    cols: Array<TableColumn> = [
        {
            field: '',
            header: 'Checkbox',
            pinned: true,
            columnCheckBox: true,
            sort: false,
            style: { 'width': '50px', 'min-width': '50px', 'max-width': '50px' }
        },
        {
            field: 'email',
            header: 'EDGE Exam Applicant Email',
            pinned: true,
            sort: true,
            sortName: 'email',
            filter: { type: FilterTypes.text },
        },
        {
            field: 'firstName',
            header: 'First Name',
            pinned: false,
            sort: true,
            sortName: 'firstName',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'lastName',
            header: 'Last Name',
            sort: true,
            sortName: 'lastName',
            filter: { type: FilterTypes.text }
        },
        //{
        //    field: 'partner',
        //    header: 'Training Partner',
        //    sortName: 'partner',
        //    filter: { type: FilterTypes.text }
        //},
        {
            field: 'role',
            header: 'Applicant Type',
            sort: true,
            sortName: 'role',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'country',
            header: 'Country',
            sort: true,
            sortName: 'country',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'city',
            header: 'City',
            sort: true,
            sortName: 'city',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'examVersion',
            header: 'Exam Version',
            sort: true,
            sortName: 'examVersion',            
        },
        {
            field: 'examCode',
            header: 'Exam Code',
            sort: true,
            sortName: 'examCode',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'updatedOn',
            header: 'Last Modified',
            translationKey: 'updatedOn',
            sort: true,
            sortName: 'updatedOn',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        }
    ];
}

